var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tabs',{attrs:{"background-color":"grey lighten-3 tabs_mail"},model:{value:(_vm.tabIndex),callback:function ($$v) {_vm.tabIndex=$$v},expression:"tabIndex"}},_vm._l((_vm.tabs),function(item,index){return _c('v-tab',{key:index,on:{"change":function($event){return _vm.$emit('updateTab', index)}}},[_c('span',[_vm._v(_vm._s(item))])])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }